import { pessoaModel } from '@/models/pessoa'

export const fornecedorModel = {
  fornecedor: function () {
    return {
      id: '',
      tpfornecedor: '',
      pessoa_id: '',
      pessoa: new pessoaModel.pessoa(),
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Fornecedor/_model/fornecedor.js